import { defineMessages } from 'react-intl'

export const scope = 'qrq.modals'

export default defineMessages({
	deleteMessage: {
		id: `${scope}.deleteMessage`
	},
	yes: {
		id: `${scope}.yes`
	},
	no: {
		id: `${scope}.no`
	},
	ok: {
		id: `${scope}.ok`
	},
	error: {
		id: `${scope}.error`
	}
})
